import { entities } from '@shared/constants/entities';
import { HasPermission } from '@features/roles/guards/has-permission';
import { SearchInput } from '@src/design-system/molecules/search-input';
import { Button } from '@src/design-system/button';
import { ButtonGroup } from '@src/design-system/button-group';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';

import { CreateOrEditReminderTemplate } from '@src/shared/features/reminders/dialogs/create-or-edit-reminder-template';
import { Add } from 'iconsax-react';
import {
  ReminderTemplatesActiveFilterChips,
  ReminderTemplatesFilterDialog,
} from './reminder-templates-filters';
import { TemplatesLayoutSwitcher } from './templates-layout-switcher';

export const ReminderHeaderBar = () => {
  return (
    <div className='bg-white border-b m-4 border-primary-200 pb-4 flex justify-between items-center'>
      <div className='flex items-center flex-wrap gap-4'>
        <ButtonGroup>
          <SearchInput paramsToExcludeFromUrl={['page_number']} />
          <ReminderTemplatesFilterDialog />
        </ButtonGroup>

        <ReminderTemplatesActiveFilterChips />
      </div>
      <div className='flex items-center gap-3'>
        <HasPermission
          action='add'
          entity={entities.reminderTemplate}
        >
          <Dialog>
            <DialogTrigger asChild>
              <Button
                size='sm'
                className='flex justify-center items-center rounded-xl'
              >
                <Add size={20} />
                Create Template
              </Button>
            </DialogTrigger>
            <DialogContent
              onOpenAutoFocus={(e) => e.preventDefault()}
              className='flex w-full max-w-[78%] flex-col overflow-hidden'
            >
              <CreateOrEditReminderTemplate />
            </DialogContent>
          </Dialog>
        </HasPermission>
        <TemplatesLayoutSwitcher />
      </div>
    </div>
  );
};
